export default __webpack_public_path__ + "static/media/ladrillos-consejo-1.6f837c14.jpg";